export enum ShippingMethod {
  FedEx = 'FedEx',
  UPS = 'UPS'
}
